const getDefaultState = () => {
	return {
		message: ''
	}
}

const state = getDefaultState()

const getters = {
	getSuccessBarMessage: state => state.message
}

const mutations = {
	resetSuccessBarState: (state) => Object.assign(state, getDefaultState()),
	setSuccessBarMessage: (state, message) => {
		if (state.message == message) {
			message += ' ';
		}
		state.message = message;
	}
}

const actions = {

}

export default {
	state,
	getters,
	mutations,
	actions
}
